<template>
  <h1>Dashboard</h1>
</template>
<script>
export default {
  name: "HomePage",
};
</script>
<style lang="scss"></style>
